module.exports = __webpack_public_path__ + "static/media/spanish-plural-noun.f26de753.jpg";